import React from 'react';
import qs from 'query-string';
import { ImageAspectBox16x9 } from './ImageAspectBox/ImageAspectBox';
export const VideoEmbed = ({ url = '', width, height, wrapper = true, fullWidth = false, }) => {
    function videoId(videoUrl) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = videoUrl.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
    }
    const embedUrl = `https://www.youtube.com/embed/${videoId(url)}?${qs.stringify({
        autoplay: 0,
        iv_load_policy: 3,
        playsinline: 1,
        rel: 0,
        showinfo: 0,
    })}`;
    const params = {};
    if (width)
        params.width = width;
    if (height)
        params.height = height;
    if (fullWidth)
        params.style = { maxWidth: 'unset' };
    const frame = (React.createElement("iframe", Object.assign({ title: "video", src: embedUrl, frameBorder: "0", allowFullScreen: true, allow: "encrypted-media" }, params)));
    if (wrapper) {
        return (React.createElement(ImageAspectBox16x9, { "data-testid": "video-component", style: params.style }, frame));
    }
    return frame;
};
//# sourceMappingURL=VideoEmbed.js.map